import { useArticleMediaViewer } from '../../articleFolder/useArticleMediaViewer';
import { Box, Typography } from '@mui/material';
import { toContentItemShape } from '../../content/machineContentApi';
import RichTextDisplay from '../../richText/RichTextDisplay';
import ContentMediaGallery from '../../contentMedia/ContentMediaGallery';
import { getContentGalleryItems } from '../../../utils/contentMediaUtils';
import '../../../css/machines/modeEtConsigne.css';

/** Published pedagogical items on the public QR page — same viewer as articles. */
const PublicMachineContent = ({ items = [] }) => {
    const { openArticleMedia, mediaViewer } = useArticleMediaViewer();
    const contents = (Array.isArray(items) ? items : []).map(toContentItemShape);

    if (contents.length === 0) {
        return null;
    }

    return (
        <Box className="modeEtConsigne_box">
            <Box className="modeEtConsigne_edit_box">
                <Typography className="modeEtConsigne_title">Contenu pédagogique</Typography>
            </Box>

            <Box className="publicPedagogy_items">
                {contents.map((item) => (
                    <Box key={item.id} sx={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                        <Typography className="publicPedagogy_itemTitle">{item?.title}</Typography>
                        {item?.description ? (
                            <Box className="publicPedagogy_description">
                                <RichTextDisplay html={item.description} />
                            </Box>
                        ) : null}
                        {getContentGalleryItems(item).length > 0 && (
                            <ContentMediaGallery
                                readOnly
                                items={getContentGalleryItems(item)}
                                onOpen={(index) => openArticleMedia(item, index)}
                            />
                        )}
                    </Box>
                ))}
            </Box>

            {mediaViewer}
        </Box>
    );
};

export default PublicMachineContent;
